import { render, staticRenderFns } from "./address-update.vue?vue&type=template&id=177fb76e&scoped=true"
import script from "./address-update.vue?vue&type=script&lang=js"
export * from "./address-update.vue?vue&type=script&lang=js"
import style0 from "./address-update.vue?vue&type=style&index=0&id=177fb76e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177fb76e",
  null
  
)

export default component.exports